import { useQuery } from '@tanstack/react-query';
import { userAdminApi } from '@/api/client';

export interface PadronCounts {
  /** Fichas del padrón, reclamadas o no. */
  total: number;
  /** Personas del padrón que todavía no han entrado a la plataforma (D-U2). */
  sinReclamar: number;
}

/**
 * Estado del padrón para el tab de Jobs.
 *
 * Va en su propio hook —y no con `useQuery` dentro del componente— porque los tests de `JobsTab`
 * renderizan sin `QueryClientProvider` y mockean los hooks uno a uno. Un `useQuery` suelto dentro
 * de una tarjeta rompe ese patrón y tumba la suite entera del tab.
 */
export function usePadronCounts() {
  return useQuery<PadronCounts>({
    queryKey: ['users', 'padron-count'],
    queryFn: async () => {
      // Dos peticiones de UNA fila: sólo interesa `totalCount`, y pedir pageSize=1 evita traer
      // 23 000 documentos para contarlos en el cliente.
      const [todas, reclamadas] = await Promise.all([
        userAdminApi.getUsers({ page: 1, pageSize: 1, includeUnclaimed: true }),
        userAdminApi.getUsers({ page: 1, pageSize: 1, includeUnclaimed: false }),
      ]);

      return {
        total: todas.totalCount,
        sinReclamar: Math.max(0, todas.totalCount - reclamadas.totalCount),
      };
    },
    staleTime: 60 * 1000,
  });
}
